<template>
  <div id="app">
    <div id="spinner_container" class="spinner-container" v-bind:class="[loading ? '' : 'hide']">
      <b-spinner variant="primary" label="ローディング中"></b-spinner>
    </div>
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  data () {
    const isSP = /(android|ip(hone|od|ad))/i.test(navigator.userAgent || navigator.vendor || window.opera)
    return {
      isSP: isSP
    }
  },
  computed: {
    ...mapState('scroll', {
      showPageBtn: state => state.showPageBtn
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  },
  created () {
    if (window.navigator.userAgent.match(/MSIE|Trident/) !== null) {
      document.getElementsByTagName('body')[0].setAttribute('class', 'ie11')
    }
  },
  methods: {
    resizeSpinner () {
      const spinner = document.getElementById('spinner_container')
      spinner.style.height = window.innerHeight + 'px'
      spinner.style.paddingTop = (window.innerHeight / 2) + 'px'
    },
    onScroll () {
      const currentYScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      const currentXScrollPosition = window.pageXOffset
      if (currentYScrollPosition > 70) {
        this.$store.commit('scroll/setShowPageBtn', true)
      } else {
        this.$store.commit('scroll/setShowPageBtn', false)
      }
      const pagetop = document.getElementById('pagetop')
      if (pagetop && !this.isSP && window.innerWidth < 970) {
        pagetop.style.right = ((window.innerWidth + currentXScrollPosition - 970) / 2) + 'px'
      }
    },
    onResize (event) {
      const pagetop = document.getElementById('pagetop')
      if (pagetop && !this.isSP) {
        if (window.innerWidth < 970) {
          pagetop.style.right = ((window.innerWidth - 970) / 2) + 'px'
        } else if (window.innerWidth < 1200) {
          pagetop.style.right = ((window.innerWidth - 970) / 2 - 70 * (window.innerWidth - 970) / 230) + 'px'
        } else {
          pagetop.style.right = ((window.innerWidth - 970) / 2 - 70) + 'px'
        }
      }
      this.resizeSpinner()
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.onResize)
    this.resizeSpinner()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss" scoped>
@charset "utf-8";
@import 'css/variables';
.spinner-container {
  text-align: center;
  &.hide {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue